import * as NoteTranscriptCommand from '../models/note/transcriptCommand';

import { Common } from '../common';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async create(
    values: Omit<NoteTranscriptCommand.CreateValues, 'source'>,
  ): Promise<NoteTranscriptCommand.NoteTranscriptCommand> {
    const url = this.common.constructPath(`/note-transcript-commands`);
    return this.common.postJSON(url, values);
  }

  async update(
    id: string,
    values: Omit<NoteTranscriptCommand.UpdateValues, 'source'>,
  ): Promise<NoteTranscriptCommand.NoteTranscriptCommand> {
    const url = this.common.constructPath(`/note-transcript-commands/${id}`);
    return this.common.patchJSON(url, values);
  }

  async remove(id: string) {
    const url = this.common.constructPath(`/note-transcript-commands/${id}`);
    return this.common.deleteJSON(url);
  }
}
